/* tslint:disable */

/**
 */
export class Units {
    ID_USER?: number;
    ID_UNIT?: number;
    TYPE_UNIT?: number;
    SYMBOL?: string;
    COEFF_A?: number;
    COEFF_B?: number;
    listSymbol?: {};
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/units.ts